export default __webpack_public_path__ + "static/bg3-c1397ee6972592a22e87910cc61fe6e1.png";